import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1033AnteileVorperiodeUebernehmenStatus: 'idle',
    startProcess1033AnteileVorperiodeUebernehmenError: undefined as any,
    loadUserParamsProcess1033AnteileVorperiodeUebernehmenStatus: 'idle',
    loadUserParamsProcess1033AnteileVorperiodeUebernehmenError: undefined as any,

    process1033AnteileVorperiodeUebernehmenList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1033AnteileVorperiodeUebernehmen = createAsyncThunk('process1033AnteileVorperiodeUebernehmenSlice/startProcess1033AnteileVorperiodeUebernehmen', async ({ process1033AnteileVorperiodeUebernehmen }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1033AnteileVorperiodeUebernehmen/`,
        prepareData(process1033AnteileVorperiodeUebernehmen),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1033AnteileVorperiodeUebernehmenStatus } = getState().process1033AnteileVorperiodeUebernehmenSlice
        return startProcess1033AnteileVorperiodeUebernehmenStatus !== 'pending'
    }
})

export const loadUserParamsProcess1033AnteileVorperiodeUebernehmen = createAsyncThunk('process1033AnteileVorperiodeUebernehmenSlice/loadUserParamsProcess1033AnteileVorperiodeUebernehmen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1033AnteileVorperiodeUebernehmen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1033AnteileVorperiodeUebernehmenStatus } = getState().process1033AnteileVorperiodeUebernehmenSlice
        return loadUserParamsProcess1033AnteileVorperiodeUebernehmenStatus !== 'pending'
    }
})

const Process1033AnteileVorperiodeUebernehmenSlice = createSlice({
    name: 'process1033AnteileVorperiodeUebernehmenSlice',
    initialState,
    reducers: {
        resetstartProcess1033AnteileVorperiodeUebernehmen: (state) => {
            state.job = undefined
            state.startProcess1033AnteileVorperiodeUebernehmenError = undefined
        },
        resetstartProcess1033AnteileVorperiodeUebernehmenError: (state) => {
            state.startProcess1033AnteileVorperiodeUebernehmenError = undefined
        },
        resetloadUserParamsProcess1033AnteileVorperiodeUebernehmen: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1033AnteileVorperiodeUebernehmenError = undefined
        },
        resetloadUserParamsProcess1033AnteileVorperiodeUebernehmenError: (state) => {
            state.loadUserParamsProcess1033AnteileVorperiodeUebernehmenError = undefined
        },
        removeFromProcess1033AnteileVorperiodeUebernehmenListById: (state, action) => {
            state.process1033AnteileVorperiodeUebernehmenList = state.process1033AnteileVorperiodeUebernehmenList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1033AnteileVorperiodeUebernehmenListByIds: (state, action) => {
            state.process1033AnteileVorperiodeUebernehmenList = state.process1033AnteileVorperiodeUebernehmenList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1033AnteileVorperiodeUebernehmenList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1033AnteileVorperiodeUebernehmenStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1033AnteileVorperiodeUebernehmenList = []
            state.startProcess1033AnteileVorperiodeUebernehmenStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1033AnteileVorperiodeUebernehmen.pending, (state) => {
            state.startProcess1033AnteileVorperiodeUebernehmenStatus = 'pending'
            state.startProcess1033AnteileVorperiodeUebernehmenError = undefined
        })
        builder.addCase(startProcess1033AnteileVorperiodeUebernehmen.fulfilled, (state, action) => {
            state.startProcess1033AnteileVorperiodeUebernehmenStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1033AnteileVorperiodeUebernehmen.rejected, (state, action) => {
            state.startProcess1033AnteileVorperiodeUebernehmenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1033AnteileVorperiodeUebernehmenError = action.error.message
            } else {
                state.startProcess1033AnteileVorperiodeUebernehmenError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1033AnteileVorperiodeUebernehmen.pending, (state) => {
            state.loadUserParamsProcess1033AnteileVorperiodeUebernehmenStatus = 'pending'
            state.loadUserParamsProcess1033AnteileVorperiodeUebernehmenError = undefined
        })
        builder.addCase(loadUserParamsProcess1033AnteileVorperiodeUebernehmen.fulfilled, (state, action) => {
            state.loadUserParamsProcess1033AnteileVorperiodeUebernehmenStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1033AnteileVorperiodeUebernehmen.rejected, (state, action) => {
            state.loadUserParamsProcess1033AnteileVorperiodeUebernehmenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1033AnteileVorperiodeUebernehmenError = action.error.message
            } else {
                state.loadUserParamsProcess1033AnteileVorperiodeUebernehmenError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1033AnteileVorperiodeUebernehmen,
    resetstartProcess1033AnteileVorperiodeUebernehmenError,
    resetloadUserParamsProcess1033AnteileVorperiodeUebernehmen,
    resetloadUserParamsProcess1033AnteileVorperiodeUebernehmenError,
    removeFromProcess1033AnteileVorperiodeUebernehmenListById,
    removeFromProcess1033AnteileVorperiodeUebernehmenListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1033AnteileVorperiodeUebernehmenSlice.actions
export default Process1033AnteileVorperiodeUebernehmenSlice.reducer
